import { Log } from "@/interfaces/Log.ts";
import { Pagination } from "@/interfaces/paginatedResponse.ts";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useLogsStore = defineStore("companyLog", () => {
  const logs = ref<Log[]>([]);
  const pagination = ref<Pagination | undefined>();
  const page = ref<number>(1);

  return {
    logs,
    pagination,
    page,

    setLog(newLogs: Log[]) {
      logs.value = newLogs;
    },
    setPage(newPage: number | string) {
      page.value = Number(newPage);
    },
    setPagination(newPagination: Pagination) {
      pagination.value = newPagination;
    },
  };
});
